/**
 * Polyfill for Promise.withResolvers()
 *
 * This method is not available in Safari < 17.4 (iOS < 17.4)
 * The polyfill provides the same functionality for older browsers.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise/withResolvers
 */

export interface PromiseWithResolvers<T> {
  promise: Promise<T>;
  resolve: (value: T | PromiseLike<T>) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- reason can be of any type
  reject: (reason?: any) => void;
}

declare global {
  interface PromiseConstructor {
    withResolvers<T = void>(): PromiseWithResolvers<T>;
  }
}

export function installPromiseWithResolversPolyfill(): void {
  if (Promise.withResolvers === undefined) {
    Promise.withResolvers = function <T>(): PromiseWithResolvers<T> {
      let resolve!: (value: T | PromiseLike<T>) => void;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- reason can be of any type
      let reject!: (reason?: any) => void;

      const promise = new Promise<T>((res, rej) => {
        resolve = res;
        reject = rej;
      });

      return { promise, resolve, reject };
    };
  }
}
